<style scoped>
    .row{
        margin-bottom: 10px;
    }
</style>
<template>
  <div>
    <Row class="row">
      <i-col span="8">
        <span>收款银行: {{ expenseGroup.payee_bank }}</span>
      </i-col>
      <i-col span="8">
        <span>账户名: {{ expenseGroup.payee_account_name }}</span>
      </i-col>
      <i-col span="8">
        <span>卡号: {{ expenseGroup.payee_bank_number }}</span>
      </i-col>
    </Row>
    <div class="text-center">
      <Table
        size="small"
        :columns="expense_columns"
        :data="expenses"
      />
    </div>
    <div
      v-if="expenseGroup.advance.id"
      class="line"
    >
      <div class="line">
        <span class="text-bold">关联预支单: </span>
        <span>{{ expenseGroup.advance.uid }}</span>
        <span> - {{ expenseGroup.advance.name }}</span>
        <span> - 金额: ￥{{ expenseGroup.advance.total_price }}</span>
        <span> - 预支时间: {{ expenseGroup.advance.paid_at }}</span>
      </div>
      <div class="line">
        <span>用途: {{ expenseGroup.advance.purpose }}</span>
      </div>
    </div>
    <div class="hr" />
    <div
      v-if="expenseGroup.user_flow"
      class="line"
    >
      <UserFlow :user_flow="expenseGroup.user_flow" />
    </div>
  </div>
</template>
<script>
  export default {
    props: ['type', 'expenseGroup', 'expenseTypeHash'],
    data() {
      return {
        //
      }
    },
    computed: {
      expenses() {
        return this.expenseGroup.expenses;
      },
      expense_columns() {
        const ret = [
          {
            title: '项目描述',
            key: 'name'
          },
          {
            title: '合同编号',
            key: 'contract_uid'
          },
          {
            title: '发票编号',
            key: 'invoice_uid'
          },
          {
            title: '发票金额',
            align: 'right',
            width: 120,
            key: 'invoice_price',
            render: (h, params) => {
              const ret = [];
              ret.push(h('span', '￥' + math.eval(params.row.invoice_price).toFixed(2) + ' '));
              return h('div', {
                'class': {
                  'text-right': true
                }
              }, ret);
            }
          },
          {
            title: '付款金额',
            align: 'right',
            width: 120,
            key: 'price',
            render: (h, params) => {
              const ret = [];
              ret.push(h('span', '￥' + math.eval(params.row.price).toFixed(2) + ' '));
              return h('div', {
                'class': {
                  'text-right': true
                }
              }, ret);
            }
          },
          {
            title: '费用类别',
            key: 'expense_type_id',
            render: (h, params) => {
              const type = this.expenseTypeHash[params.row.expense_type_id].name;
              return h('div', type);
            }
          },
          {
            title: '备注',
            key: 'desc'
          }
        ];
        if (this.type === 0) {
          ret.splice(1, 1);
        }
        return ret;
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>
